import type { TutorPaymentPolicySelectReturn } from './interfaces'

import { TutorCategoryType } from '@entities/tutor'

import { usePaymentPoliciesStore } from './store'
import { useTutorPaymentPolicySelect } from './tutor-payment-policy-select.hook'

export const useSelectDemoEla = (): TutorPaymentPolicySelectReturn => {
  const paymentPoliciesStore = usePaymentPoliciesStore()

  return useTutorPaymentPolicySelect({
    category: TutorCategoryType.DemoEla,
    label: 'Demo ELA',
    getValue: () => paymentPoliciesStore.selectedDemoEla as number | null,
    setValue: (value) => paymentPoliciesStore.setSelectedDemoEla(value),
  })
}
